import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const LocationFormCard = ({ testId }: { testId?: string } = {}) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.LOCATION)} testId={testId}>
      <FormItem
        label={<Text>{t(supConstants.BUILDING)}</Text>}
        name={['location', 'building']}
      >
        <Input maxLength={20} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.FLOOR)}</Text>}
        name={['location', 'floor']}
      >
        <Input maxLength={20} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.ROOM)}</Text>}
        name={['location', 'room']}
      >
        <Input maxLength={20} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.BED)}</Text>}
        name={['location', 'bed']}
      >
        <Input maxLength={20} />
      </FormItem>
    </FormCard>
  )
}
